export const useApiErrorResponseHandler = (errorCode) => {
    let errorMessage = "";
    const internalAppError = "INTERNAL APPLICATION ERROR";
    const externalAppError = "EXTERNAL APPLICATION ERROR";
    switch (errorCode) {
        case "ERR_NETWORK":
            errorMessage = `📡 ${internalAppError}.
                            Failed to establish network connection!`;
            break;
        case "ERR_CANCELED":
            errorMessage = `📡 ${internalAppError}.
                            Connection cancelled!`;
            break;
        case "ECONNABORTED":
            errorMessage = `📡 ${externalAppError}.
                            Connection aborted!`;
            break;
        case "ETIMEDOUT":
            errorMessage = `📡 ${externalAppError}.
                            Connection timed out!`;
            break;
        default:
            errorMessage = `📡 ${internalAppError}.
                            Process failed!`;
    }
    return errorMessage;
}